/**
 * Model for Facebook user data.
 * @param {string} id
 * @constructor
 * @extends {Foundation.Promise}
 */
Foundation.Facebook.User = function (id) {
    Foundation.Promise.call(this);

    var user = new Foundation.Facebook.API("GET", `/${id}`, {
      "fields": "id,name,email"
    });
    
    user.then(function () {
        this.fulfillWith(user);
    }.bind(this));
};
Foundation.inherit(Foundation.Facebook.User, Foundation.Promise);
